import React, { useState } from "react";
import "../css/mobileapp.css";
import logo1 from "../assets/logo.png"; 

function importAll(r) {
  return r.keys().map(r);
}

const images1 = importAll(
  require.context("../assets/gallery", false, /\.(png|jpe?g|webp)$/)
);

const images2 = importAll(
  require.context("../assets/gallery3", false, /\.(png|jpe?g|webp)$/)
);

const images3 = importAll(
  require.context("../assets/gallery2", false, /\.(png|jpe?g|webp)$/)
);

function MobileGallery() {
  const [selectedImg, setSelectedImg] = useState(null);

  const renderGallery = (images, title) => (
    <div className="gallery-page">
      <h2 className="gallery-heading">{title}</h2>

      <div className="gallery-grid">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt="gallery"
            className="gallery-img"
            onClick={() => setSelectedImg(img)}
          />
        ))}
      </div>
    </div>
  );

  return (
    <>
        <div className="mobile-container">
      
<div className="mobile-header">
  <img src={logo1} alt="TVK Logo" className="mobile-logo" />
</div>
      {renderGallery(images1, "புகைப்படங்கள்")}
      {renderGallery(images2, "புகைப்படங்கள்")}
      {renderGallery(images3, "புகைப்படங்கள்")}

      
      {selectedImg && (
        <div className="img-modal" onClick={() => setSelectedImg(null)}>
          <div
            className="img-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={selectedImg} alt="preview" />

            <div className="img-actions">
              <a href={selectedImg} download className="save-btn">
                ⬇ Save
              </a>
              <button
                className="close-btn"
                onClick={() => setSelectedImg(null)}
              >
                ✖
              </button>
            </div>
          </div>
        </div>
        
      )}
      </div>
    </>
  );
}

export default MobileGallery;